<template>
  <component :is="layoutComponent" />
</template>

<script>
import { computed,defineAsyncComponent  } from 'vue';
import { useUserStore } from '@/stores/userStore.js';

export default {
  setup() {
    const userStore = useUserStore();
    const PostLoginLayout = defineAsyncComponent(() =>
      import('@/layouts/PostLoginLayout.vue')
    );
    const PreLoginLayout = defineAsyncComponent(() =>
      import('@/layouts/PreLoginLayout.vue')
    );
    // Ensure that `layoutComponent` returns a function that imports the component
    const layoutComponent = computed(() => {
      return (userStore.isLoggedIn && userStore.getuserType==1)
        ? PostLoginLayout  // Dynamic import for logged in layout
        : PreLoginLayout;  // Dynamic import for pre-login layout
    });

    return { layoutComponent };
  },
};
</script>